import * as Cookies from '../utils/cookies';
import axios from 'axios';

export async function registerNewPlayer(userId, sentence, city, school, grade, shirtSize) {
  const token = Cookies.getToken();


  const res = await axios({
    method: 'POST',
    url: process.env.REACT_APP_API_URL + `/api/users/players/`,
    headers: { Authorization: `Bearer ${token}` },
    data: {
      user_id: userId,
      sentence: sentence,
      team: null,
      city: city,
      school: school,
      grade: grade,
      status: 'no_team',
      shirt_size: shirtSize,
    },
  });
  return res;
}
